import { initializeApp } from "firebase/app";
import { getAuth, RecaptchaVerifier } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyASWmcOvdT1CHqTG1ogPxQKQzM2FAIkAKE",
  authDomain: "hallticket-auth.firebaseapp.com",
  projectId: "hallticket-auth",
  storageBucket: "hallticket-auth.firebasestorage.app",
  messagingSenderId: "826318672540",
  appId: "1:826318672540:web:f2ef737ee599d8cc39d359"
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

export function getRecaptchaVerifier() {
  const w = window as any;
  if (!w.recaptchaVerifier) {
    w.recaptchaVerifier = new RecaptchaVerifier(auth, "recaptcha-container", {
      size: "invisible",
    });
  }
  return w.recaptchaVerifier as RecaptchaVerifier;
}

export function clearRecaptchaVerifier() {
  const w = window as any;
  if (w.recaptchaVerifier) {
    w.recaptchaVerifier.clear();
    w.recaptchaVerifier = null;
  }

  const recaptchaContainer = document.getElementById("recaptcha-container");
  if (recaptchaContainer) {
    recaptchaContainer.innerHTML = "";
  }
}

export default app;
